module.exports = __webpack_public_path__ + "static/img/background.fa8b905.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.jpg
// module id = AS41
// module chunks = 1